import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";
import copy from "copy-to-clipboard";

export default async function shareExternally(url) {
  const platform = Capacitor.getPlatform();

  if (platform === "android" || platform === "ios") {
    await Share.share({
      url: url,
    });
  } else {
    copy(url);
    window.popupAlert("Link copied to clipboard");
  }
}
